/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import { combineReducers } from '@reduxjs/toolkit';
import orderDetailsValidations from './orderDetailsValidations';

const validationReducers = {
    campingOrderDetails: orderDetailsValidations,
};

export default combineReducers(validationReducers);
